import { LineType } from "react-terminal-ui";

export const schools = [
  {
    type: LineType.Output,
    value:
      "EFREI Paris – M.Eng. in Computer Science and Software Engineering - 09/2018 - 09/2021",
  },
  {
    type: LineType.Output,
    value:
      "Polytech Paris-Saclay – Associate’s degree in General engineering - 09/2016 - 09/2018",
  },
];
